export default __webpack_public_path__ + "images/822f77c5e7f7504149ae4ae8fcf77be5.svg";